import clsx from 'clsx';
import React from 'react';
import ChatModal from '../../pages/Chat/ChatModal';

export default function MessageCandidate({ setOpenUser, isSelf, created_at, name, id, senderName }) {
  return (
    <div className={'order-2 mx-2'}>
      {!isSelf && (
        <div className="text-black font-medium ml-4  " style={{ fontSize: '10px' }}>
          {senderName}
        </div>
      )}
      <div class="  p-3 border-1 rounded-lg flex flex-col gap-3 " style={{ borderColor: !isSelf ? 'rgb(229, 231, 235)' : 'rgba(0, 178, 164, 0.6)' }}>
        <div className="flex gap-2">
          {' '}
          <div class="bg-[#E5E5E5] w-[32px] h-[32px]  flex items-center justify-center rounded-md" bis_skin_checked="1">
            <svg xmlns="http://www.w3.org/2000/svg" width="16px" height="16px" viewBox="0 0 24 24">
              <path fill="rgba(0,0,0,0.6)" d="M12 4a4 4 0 0 1 4 4a4 4 0 0 1-4 4a4 4 0 0 1-4-4a4 4 0 0 1 4-4m0 10c4.42 0 8 1.79 8 4v2H4v-2c0-2.21 3.58-4 8-4"></path>
            </svg>
          </div>
          <div className="">
            {' '}
            <div className="text-sm font-font-semibold">{name}</div>
            <div className="text-xs text-gray-400 -mt-1">Соискатель</div>
          </div>
        </div>
        <div className="flex gap-1">
          <ChatModal userType="candidate" userId={id} textBtn="Написать" className="text-center border rounded py-1 px-4 bg-button text-white hover:bg-button-hov  transition ease-in-out duration-300 text-sm " />
          {/* <button type="button" className="text-center border rounded py-1 px-4 bg-button text-white hover:bg-button-hov  transition ease-in-out duration-300 text-sm ">
            Написать
          </button> */}
          {/* </div> */}
          <button
            type="button"
            className=" text-center border border-button border-1 rounded py-1 px-4 bg-white text-button   transition ease-in-out duration-300 text-sm hover:text-white  hover:bg-button"
            onClick={() => {
              setOpenUser(id);
            }}>
            Открыть
          </button>
        </div>
      </div>
      <div className={clsx('text-gray-400  mt-1 mr-4', isSelf ? 'text-end' : 'text-end')} style={{ fontSize: '10px' }}>
        {created_at}
      </div>
    </div>
  );
}
